import React from "react";
import "./css/divisorCenterWhite.css";

const DivisorCenterWhite = ({ title, subtitle }) => {
  return (
    <div className="text-center">
      <div className="d-flex align-items-center">
        <div className="flex-grow-1 border-top line-white ms-5"></div>
        <h5 className="mx-4 text-center text-gris-bold-white-hv">{title}</h5>
        <div className="flex-grow-1 border-top line-white me-5"></div>
      </div>
      <div className="text-center color-text-body-white-hv">{subtitle}</div>
    </div>
  );
};
export default DivisorCenterWhite;
